<template>
  <AbsPopup id="UploadPost" title="글 등록 하기" type="confirm" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div class="popup-body">
        <div class="info">
          <div class="cover">
            <div class="coverimg">
              <span v-if="!img">표지없음</span>
              <img v-else :src="img"/>
            </div>
          </div>
          <div>
            <li>
              <span>제목</span>
              <span>{{ title }}</span>
            </li>
            <li>
              <span>부제목</span>
              <span>{{ subtitle }}</span>
            </li>
            <li>
              <span>저작공간</span>
              <span>{{ work }}</span>
            </li>
            <li>
              <span>카테고리</span>
              <span>{{ category }}</span>
            </li>
            <li>
              <span>분류</span>
              <span><b v-html="genre"></b> / <span v-html="subgenre"></span></span>
            </li>
            <li>
              <span>공개</span>
              <span>{{ point }}</span>
            </li>
            <li>
              <span>메인공개</span>
              <span>{{ mainopen }}</span>
            </li>
            <li>
              <span>권한</span>
              <span>{{ permit }}</span>
            </li>
            <li>
              <span>등급</span>
              <span v-html="adult"></span>
            </li>
          </div>
        </div>
        <div class="description">
          <span>저작권자의 동의 없이 내용의 일부를 인용하거나 발췌하는 것을 금합니다.<br />모든 책임은 콘텐츠를 전시한 [본인]이 책임을 지게 됩니다.</span>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import {Genre, State, numberToComma} from '@/components/js/Utils'
import UImageLoader from '@/components/js/UImageLoader.js'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    this.$emit('loading', false)
  },
  beforeDestroy () {
  },
  data () {
    return {
    }
  },
  name: 'UploadPost',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '등록확인', state: 'active', click: this.submit}
      ]
    },
    img () {
      return this.option.param.cover
    },
    title () {
      return this.option.param.book.text
    },
    subtitle () {
      return this.option.param.post.subtitle.substring(0, 40)
    },
    work () {
      return this.option.param.work.name
    },
    category () {
      return this.option.param.category.text
    },
    genre () {
      return Genre.toString(this.option.param.book.genre)
    },
    subgenre () {
      console.log(this.option.param.post.body)
      return Genre.subgenreString(this.option.param.book.genre, this.option.param.book.subgenre)
    },
    point () {
      if (this.option.param.post.point !== 0) {
        return numberToComma(this.option.param.post.point)
      } else {
        if (this.option.param.post.state & State.VISIBLE) {
          return '비공개'
        } else {
          return '무료'
        }
      }
    },
    mainopen () {
      if (this.option.param.book.state & State.MAINOPEN) {
        return '메인 화면에 노출 안함'
      } else {
        return '메인 화면에 노출 함'
      }
    },
    permit () {
      var p = []
      if (!(this.option.param.post.state & State.COMMENT)) {
        p.push('댓글')
      }
      if (!(this.option.param.post.state & State.SEARCH)) {
        p.push('검색')
      }
      if (!(this.option.param.post.state & State.SHARE)) {
        p.push('공유')
      }
      return p.join(' / ') + ' 허용'
    },
    adult () {
      if (this.option.param.book.state & State.ADULT) {
        return '<span class="require"><b>이 콘텐츠는 성인물 입니다.</b></span>'
      } else {
        return '<span class="active"><b>이 콘텐츠는 전체이용가 입니다.</b></span>'
      }
    }
  },
  methods: {
    submit () {
      console.log('submit')
      this.$emit('loading', true)
      var d = document.createElement('div')
      d.innerHTML = this.option.param.post.body
      var ar = d.querySelectorAll('img')
      console.log(ar)
      var i
      var img = []
      var id = []
      for (i = 0; i < ar.length; i++) {
        if (ar[i].src.indexOf('data:image') !== -1) {
          img.push(UImageLoader.dataURLToBlob(ar[i].src))
          id.push(ar[i].id)
          ar[i].src = ar[i].id + '.jpeg'
        }
      }
      this.option.param.post.body = d.innerHTML
      this.option.param.post.prev = d.innerText.substring(0, 100)
      var form = new FormData()
      if (this.option.param.postCover) {
        if (this.option.param.cover.indexOf('data:image') !== -1) {
          form.append('postCover', this.option.param.postCover)
        } else {
          form.append('cover', true)
        }
      }
      for (i = 0; i < img.length; i++) {
        form.append('post[]', img[i], id[i])
      }
      console.log(this.option.param)
      var footnote = []
      for (i = 0; i < this.option.param.footnotelist.length; i++) {
        footnote.push({id: this.option.param.footnotelist[i].id, title: this.option.param.footnotelist[i].title, message: this.option.param.footnotelist[i].message})
      }
      form.append('work', JSON.stringify(this.option.param.work))
      form.append('category', JSON.stringify(this.option.param.category))
      this.option.param.post.subtitle = this.option.param.post.subtitle.substring(0, 40)
      form.append('book', JSON.stringify(this.option.param.book))
      form.append('post', JSON.stringify(this.option.param.post))
      form.append('footnote', JSON.stringify(footnote))
      console.log(this.option.param.book)
      console.log(JSON.stringify(this.option.param.post))
      this.$http.post('/api/library/createPost', form, {headers: {'Content-Type': 'multipart/form-data'}}).then((e) => {
        console.log(e)
        if (e.success) {
          this.$emit('loading', false)
          this.$emit('submit', e.data)
        } else {
        }
      })
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
#UploadPost {
  padding: 10px 0;
  width: 530px;
}
.popup-body {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.popup-body .info {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
  border-bottom: 1px solid var(--line-base);
}
.popup-body .description {
  padding: 10px 10px 10px 10px;
  text-align: left;
  line-height: 25px;
}
.popup-body .info div {
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 30px;
}
.popup-body .info li {
  display: flex;
}
.popup-body .info li span:first-child {
  text-align: right;
  width: 65px;
  min-width: 65px;
  margin-right: 20px;
  color: var(--text-title);
}
.popup-body .info li span:last-child {
  text-align: left;
  color: var(--text-description);
}
.coverimg {
  min-width: 200px;
  width: 200px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--line-base);
  margin-right: 10px;
}
.coverimg img {
  width: 200px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/UploadPost.vue